import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useGetShoppingCartDetailsQuery } from '@/shoppingCart/services/shopping-cart.service';
import { ClientStorageService } from '@/common/services/client-storage.service';

import { DiContainer } from '@/di/di-container';
import LogoImage from './icons/logo.svg';
import { Button } from '@/configurator/components/shared';
import { useGetProfileQuery } from '@/profile/services/profile.service';

const clientStorageService = DiContainer.get(ClientStorageService);

export function PrimaryLayoutHeader() {
  const sessionId = clientStorageService.getUUID();

  const { refetch } = useGetShoppingCartDetailsQuery({
    session: sessionId,
    sharedId: new URLSearchParams(window.location.search).get('shared_uuid'),
  });

  const { data: profileData } = useGetProfileQuery(sessionId);

  if (profileData) {
    localStorage.setItem('owner_uuid', profileData.data.attributes.uuid);
  }

  const openCallibriCall = () => {
    const callibriIcon = document.getElementsByClassName(
      'callibri_wrap_pict_tab'
    )[0] as HTMLElement;
    if (callibriIcon) {
      callibriIcon.click();
      document.getElementById('switchForCall')?.click();
    } else {
      const callibriIcon2 = document.getElementsByClassName(
        'callibri_hook_avatar'
      )[0] as HTMLElement;
      if (callibriIcon2) {
        callibriIcon2.click();
        document.getElementById('switchForCall')?.click();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('onShoppingCartUpdate', refetch);
    return () => {
      document.removeEventListener('onShoppingCartUpdate', refetch);
    };
  }, []);

  return (
    <div className="header w-full ">
      <div className="header__inner mx-auto max-w-[1440px] w-[90%] flex justify-between items-center py-[16px]">
        <div className="header__col flex items-center">
          <Link className="logo__button inline-block mr-[32px]" to="/">
            <img width={100} height={28} src={LogoImage} />
          </Link>
          <a
            className="phone_number mr-[24px] hover:text-black"
            href="tel:+788005559983"
            target="_parent">
            8 (800) 555 99 83
          </a>
          <Button
            className="call_button px-[16px] py-[8px] text-[16px] font-medium"
            onClick={openCallibriCall}>
            Обратный звонок
          </Button>
        </div>
      </div>
    </div>
  );
}
